module.exports = __webpack_public_path__ + "img/favorite.be27ebf0.svg";